import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { Autoplay, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';

const JA: React.FC = () => {
    const { t } = useLang('delta3series');
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767854822867-jwckgx-compressed-Frame%201000008977.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767854848914-oiqvlw-compressed-Frame%201000008978.jpg',
        },
        // {
        //     pc: 'https://websiteoss.ecoflow.com/upload/image/1740638949102/KV2%20(1)%20(1).jpg',
        //     h5: 'https://websiteoss.ecoflow.com/upload/image/1740638949525/M_KV%20(1).jpg',
        // },
    ];
    return (
        <div className={styles.comp} id="d3-A">
            {/* <EcoSection title={t('A_text1')} desc={t('A_text2')} /> */}

            <Swiper
                className="eco-swiper-auto"
                style={{ width: '100%', height: '100%' }}
                modules={[Autoplay, EffectFade]}
                effect="fade"
                spaceBetween={0}
                slidesPerView={1}
                initialSlide={0}
                noSwiping={true}
                autoplay={{
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                }}
            >
                {items.map((item, index) => (
                    <SwiperSlide className="swiper-no-swiping" key={index}>
                        {/* <div className="content">
                            <div className="title">{t('A_text1')}</div>
                            <div className="title">{t('A_text2')}</div>
                        </div> */}
                        <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default JA;
